import type { Schedule, TimeRange, Weekday } from '../types';
import { WEEKDAYS } from '../types';

export interface InvalidScheduleEntry {
  day: Weekday;
  missingEdge: 'from' | 'to';
}

export const isValidTimeRange = (range: TimeRange): boolean => (range.from === null) === (range.to === null);

export const findInvalidScheduleEntries = (schedule: Schedule): InvalidScheduleEntry[] =>
  WEEKDAYS.flatMap<InvalidScheduleEntry>(day => {
    const range = schedule[day];
    if (isValidTimeRange(range)) return [];
    return [{ day, missingEdge: range.from === null ? 'from' : 'to' }];
  });
